import { Directive, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Utility for providing base component functionality
 */
@Directive()
export abstract class BaseAbstractComponent implements OnDestroy {
    protected $destroy: Subject<void> = new Subject<void>();

    ngOnDestroy(): void {
        this.preOnDestroy();
        this.$destroy.next();
        this.$destroy.complete();
    }

    /**
     * Typescript does not have a way to declare methods final/frozen
     * see https://github.com/microsoft/TypeScript/issues/8306
     * Adding abstract hooks to avoid ngOnDestroy being overridden
     */
    abstract preOnDestroy();
}
